module.exports = __webpack_public_path__ + "img/baseline-directions_walk-24px.37eee5e9.svg";